<mat-card class="card-demo">
  <mat-card-title class="aa">
    <div class="combination screen">
      <button mat-button (click)="toggleGuidenote()" class="title">
        @if (hideGuidenote) {
        <mat-icon matTooltip="Show Guide Note" matTooltipClass="tooltip1"
          >add</mat-icon
        >
        } @if (!hideGuidenote) {
        <mat-icon matTooltip="Hide Guide Note" matTooltipClass="tooltip1"
          >remove</mat-icon
        >
        }
      </button>
      @if (hasState) {
      <button
        mat-button
        (click)="showState()"
        class="title"
        [ngClass]="{ highlight: selectedState != null }"
      >
        <mat-icon matTooltip="State" matTooltipClass="tooltip1"
          >location_on</mat-icon
        >
      </button>
      } @if (selectedState) {
      <h5 class="title">&#64;{{ selectedState }}</h5>
      }
      <button mat-button (click)="printRulebook()" class="title">
        <mat-icon>print</mat-icon>
      </button>
    </div>
    <button mat-button (click)="onBackSummary()">
      <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon>Back
      to Summary
    </button>
  </mat-card-title>

  <!--mat-card-subtitle>{{this.message}}
</mat-card-subtitle-->
  <mat-card-content class="large">
    <div fxLayout="column" fxFill>
      <div fxLayout fxFlex>
        <div class="one" fxFlex="70" fxLayoutAlign="start start">
          <app-rulebook-content [rb$]="this.rulebook$"> </app-rulebook-content>
        </div>
        <div class="two" fxFlex="30" fxLayoutAlign="start start">
          <app-rulebook-list
            [csskey]="this.csskey"
            [rbList]="this.rulebookList"
            [selected]="this.rbkey"
            (selectedkey)="onClickRulebook($event)"
            class="list-rulebook"
          >
          </app-rulebook-list>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-footer class="bottomPad">
    <div class="hint"></div>
  </mat-card-footer>
</mat-card>
@if (service.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}
